import { Box, Typography } from "@mui/material";
import RecentlyFoundLabel, {
  isRecentlyFound,
} from "../../../posture/controls/components/RecentlyFoundLabel";
import ChipColor from "../../../remediation/plan/components/ChipColor";
import IntegrationImage from "../../integrations/components/IntegrationImage";
import { IntegrationsMapping } from "../../integrations/IntegrationsMapping";
import EntityFavoritesButton from "../components/EntityDrawer/EntityFavoritesButton";
import { getRiskNameFromValue } from "../utils";

export const getSharedColumnsMultiTenant = (assets, colors) => {
  return [
    {
      field: "display_name",
      headerName: "Name",
      flex: 2,
      minWidth: 180,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
          <EntityFavoritesButton entityId={params.row?.entity_id} icon={true} />

          <Typography variant="caption" sx={{ flexGrow: 1 }}>
            {params.value}
          </Typography>
          {isRecentlyFound(
            params.row?.first_collected_timestamp?.timestamp_utc
          ) && (
            <RecentlyFoundLabel
              foundTimestamp={
                params.row?.first_collected_timestamp?.timestamp_utc || ""
              }
            />
          )}
        </Box>
      ),
    },
    {
      field: "risk",
      headerName: "Risk",
      minWidth: 90,
      flex: 0.5,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      resizable: false,
      valueFormatter: (params) => getRiskNameFromValue(params.value),
      renderCell: (params) => (
        <ChipColor
          value={params.value}
          type={"entity_risk"}
          width={62}
          style={{ padding: "6px", borderRadius: "8px" }}
          useShortLabel
        />
      ),
    },
    {
      field: "sources",
      headerName: "Source",
      minWidth: 120,
      flex: 1,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      sortComparator: (v1, v2) => {
        if (v1.length !== v2.length) {
          return v1.length - v2.length;
        }
        const v1Sorted = [...v1].sort();
        const v2Sorted = [...v2].sort();
        return v1Sorted.join(",").localeCompare(v2Sorted.join(","));
      },
      valueFormatter: (params) =>
        params.value
          .map((source) => IntegrationsMapping[source]?.displayName)
          .join(", "),
      renderCell: (params) => {
        // TODO - make this better! reactive instead of const max tool (like the related assets cell), and tooltip on the number
        const maxToolsDisplay = 4;
        return (
          <>
            {params.value
              .map((integration) => (
                <IntegrationImage
                  key={integration}
                  name={integration}
                  width={"40px"}
                />
              ))
              .slice(0, maxToolsDisplay)}
            {params.value.length > maxToolsDisplay
              ? `+${params.value.length - maxToolsDisplay}`
              : null}
          </>
        );
      },
    },
    {
      field: "customer_id",
      headerName: "Customer ID",
      flex: 2,
      minWidth: 180,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      renderCell: (params) => (
        <Box
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
          sx={{
            backgroundColor: colors.grey_8percent,
            borderRadius: "12px",
            padding: "4px 8px",
            border: `0.5px solid ${colors.button_outlined_inherit_enabled_stroke}`,
          }}
        >
          <Typography variant="caption" sx={{ flexGrow: 1 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
  ];
};
